import { useMutation } from '@tanstack/react-query';
import type { ITransactionsPayload } from 'api/resources/transactions';
import { postTransactions } from 'api/resources/transactions';

export const usePostTransactions = (token: string) => {
	return useMutation({
		mutationFn: (payload: ITransactionsPayload) =>
			postTransactions({ token, payload }),
	});
};
